import { forwardRef, memo, type AnchorHTMLAttributes } from "react";
import { Link as RouterLink, type LinkProps as RouterLinkProps } from "react-router-dom";
import { twMerge } from "tailwind-merge";

type LinkVariant = "secondary" | "unstyled";

type SharedLinkProps = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "href"> &
    Pick<RouterLinkProps, "replace" | "state" | "preventScrollReset" | "relative" | "reloadDocument"> & {
        href?: string;
        to?: RouterLinkProps["to"];
        variant?: LinkVariant;
    };

const isInternalHref = (href: string): boolean => {
    if (href.startsWith("/")) return true;
    return false;
};

const LinkBase = forwardRef<HTMLAnchorElement, SharedLinkProps>(
    ({ href, to, variant = "secondary", className, onClick, ...props }, ref) => {
        const isInternal = href ? isInternalHref(href) : false;

        const baseStyles = "text-sm transition-colors duration-100";

        const combinedClassName = twMerge(baseStyles, className);

        if (isInternal && href) {
            return (
                <RouterLink to={href} className={combinedClassName} onClick={onClick} ref={ref} {...props}>
                    {props.children}
                </RouterLink>
            );
        }

        return (
            <a href={href} className={combinedClassName} onClick={onClick} ref={ref} {...props}>
                {props.children}
            </a>
        );
    },
);

export const Link = memo(LinkBase);

Link.displayName = "Link";
